import map from 'lodash/map';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const srcSet = (filepath, scale) =>
  map(scale, size => {
    if (typeof size === 'number') {
      return `/images/${filepath}@${size}x.png ${size}x`;
    }
    return `/images/${filepath}@${size.atSize}.png ${size.width}w`;
  }).join(', ');

const Picture = ({ alt, className, filepath, scale, sources, style }) => (
  <picture
    className={typeof className === 'string' ? className : cx(...className)}
  >
    {sources ? (
      map(sources, source => <source {...source} />)
    ) : (
      <source srcSet={`/images/${filepath}.svg`} type="image/svg+xml" />
    )}
    <img
      alt={alt}
      src={`/images/${filepath}.png`}
      srcSet={srcSet(filepath, scale)}
      style={style}
    />
  </picture>
);

Picture.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    ),
  ]),
  filepath: PropTypes.string.isRequired,
  scale: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape({
        atSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        width: PropTypes.number.isRequired,
      }),
    ])
  ),
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      srcSet: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ),
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

Picture.defaultProps = {
  alt: '',
  className: [],
  scale: [2],
  sources: null,
  style: undefined,
};

export default Picture;



// WEBPACK FOOTER //
// ./src/components/Picture/index.js